import { IAppConfiguration } from '../app/cross-cutting-concerns/configuration/interfaces/IAppConfiguration';

export const appConfig: IAppConfiguration = {};
